import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import { deleteCharity } from "../actions";
import toast from "react-hot-toast";
import CharityIssueCharityViewModel from "../../../../viewModels/CharityIssueCharityViewModel";
import { deleteCharityIssueCharity } from "../actions/CharityIssueCharity";

export function CreateCharity() {
  return (
    <Link to={"/admin/charities/create"}>
      <Button className="mt-4">
        Create Charity
        <Icon icon={PlusIcon} label="Create Charity" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateCharity({ id }: { id: number }) {
  return (
    <Link to={`/admin/charities/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteCharity({ id }: { id: number }) {
  const navigate = useNavigate();

  const deleteCharityWithId = deleteCharity.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this charity?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteCharityWithId, {
    success: false,
  });
  useEffect(() => {
    if (state.success) {
      navigate("/admin/charities?reload=true", { replace: true });
      toast.success("Charity deleted successfully");
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}

export function UpdateCharityIssueCharity({ charityIssueCharity }: { charityIssueCharity: CharityIssueCharityViewModel }) {
  return (
    <Link to={`/admin/charities/edit/${charityIssueCharity.id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteCharityIssueCharity({ charityIssueCharity }: { charityIssueCharity: CharityIssueCharityViewModel }) {
  const navigate = useNavigate();
  
  const deleteCharityIssueCharityWithId = deleteCharityIssueCharity.bind(null, charityIssueCharity.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this charity issue?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteCharityIssueCharityWithId, {
    success: false,
  });
  useEffect(() => {
    if (state.success) {
      navigate(`/admin/charities/edit/${charityIssueCharity.charityId}?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);
  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}
